import React, { useEffect, useState } from "react";
import { mediaUrl } from "../lib/api";
import api from "../lib/api";

export default function About() {
  const [data, setData] = useState({ sections: [] });
  const [img, setImg] = useState("");
  useEffect(() => {
    api.get("/content/about").then((r) => setData(r.data.data || { sections: [] })).catch(() => {});
    api.get("/content/homepage").then((r) => setImg(r.data.data?.editorial_image || "")).catch(() => {});
  }, []);
  return (
    <div>
      <section className="relative h-[50vh] min-h-[380px] bg-espresso overflow-hidden">
        {img && <img src={mediaUrl(img)} alt="" className="absolute inset-0 w-full h-full object-cover opacity-70" />}
        <div className="absolute inset-0 bg-pitch/40" />
        <div className="relative h-full luxy-container flex flex-col justify-center">
          <p className="eyebrow text-ivory/70 mb-3">The House</p>
          <h1 className="font-serif font-light text-ivory text-5xl sm:text-6xl tracking-tight">About LUXYREIGN</h1>
        </div>
      </section>
      <div className="luxy-container py-16 sm:py-24 max-w-3xl">
        {(data.sections || []).map((s, i) => (
          <div key={i} className="mb-14">
            <h2 className="font-serif text-3xl text-pitch tracking-tight mb-5">{s.heading}</h2>
            <p className="text-charcoal/80 leading-relaxed text-lg font-light">{s.body}</p>
          </div>
        ))}
        <p className="text-xs text-stonemuted font-mono uppercase tracking-widest border-t border-linen pt-8">Placeholder content — the owner's full story has not yet been supplied and should be reviewed before launch.</p>
      </div>
    </div>
  );
}
